module.exports = __webpack_public_path__ + "static/img/marmalade_profile_400x370.17a7602.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marmalade_profile_400x370.jpg
// module id = InGN
// module chunks = 0